export default "__VITE_ASSET__CjWVX2y4__"